// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yz8PRAdl8yMaaOOaJBdX{flex-direction:column;gap:4px;display:flex;position:relative}.cXM5iF9OoIwIqMnfWZ1X{background:var(--background-neutral-default);border-radius:6px;justify-content:center;align-items:center;gap:4px;width:24px;height:24px;display:flex;position:absolute;left:-44px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `yz8PRAdl8yMaaOOaJBdX`,
	"blockId": `cXM5iF9OoIwIqMnfWZ1X`
};
export default ___CSS_LOADER_EXPORT___;
